<!-- <div class="d-flex" > -->


  <div [@dialogResize]="dialogState" class="dialog-content">
    <ng-container *ngIf="dialogState === 'change'">
      
      <!-- Change Password Form -->
      <div class="d-flex h-100">
        <form [formGroup]="changePasswordForm" (ngSubmit)="onSubmit()">

          <div class="shadow p-4 pb-2 loginFormMain d-flex flex-column justify-items-stretch justify-content-between h-100" style="width: 500px;">
              <div>
                  <div class="d-flex justify-content-between">
                    <h5 class="mb-4">Change Password</h5>
                    <div (click)="cancel()" style="cursor: pointer;">
                      <svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M17.9427 1.94271L16.0574 0.057373L9.00004 7.11471L1.94271 0.057373L0.057373 1.94271L7.11471 9.00004L0.057373 16.0574L1.94271 17.9427L9.00004 10.8854L16.0574 17.9427L17.9427 16.0574L10.8854 9.00004L17.9427 1.94271Z" fill="black"/>
                      </svg>
                    </div>
                  </div>

                  <hr class="m-0 mb-2" style="background-color: #E4E4E4; border: none; height: 2px;" />

                  <div class="mb-3">
                    <!-- <label class="fw-bold">User ID</label>
                    <div>{{ emailId }}</div> -->
                    <label for="refNum" class="col-form-label" style="color: #000000;font-family:'maven pro';font-weight:500;">E-mail address</label>
                    <input class="customInputFields" type="text" [value]="emailId" style="border: 1px solid #E4E4E4; border-radius: 7px;" disabled>
                  </div>
            
                  <div class="mb-3">
                    <label for="refNum" class="col-form-label" style="color: #000000;font-family:'maven pro';font-weight:500;">Old password</label>
                    <div class="position-relative">
                      <input class="customInputFields" [type]="showPassword['currentPassword'] ? 'text' : 'password'" formControlName="currentPassword" 
                            [ngClass]="{ 'is-invalid': submitted && f['currentPassword'].invalid }" style="border: 1px solid #E4E4E4; border-radius: 7px;">
                      <i class="fa eye-icon position-absolute" [ngClass]="{ 'fa-eye-slash': !showPassword['currentPassword'], 'fa-eye': showPassword['currentPassword'] }"
                            (click)="togglePasswordVisibility('currentPassword')" style="right: 10px; top: 50%; transform: translateY(-50%); cursor: pointer;"></i>
                    </div>
                    <div class="d-flex justify-content-between">
                      <div>
                        <div *ngIf="(submitted || f['currentPassword'].touched) && f['currentPassword'].errors?.['required']" class="invalid-feedback" style="display: block;">
                          Old password is required.
                        </div>
                      </div>
                      <div class="mt-1">
                        <a href="javascript:void(0)" style="color: #000000" (click)="switchToReset()">Forgot password?</a>
                      </div>
                    </div>
                  </div>

                  <!-- <div class="form-group py-2">
                    <label>Old password</label>
                    <div class="position-relative">
                      <input [type]="showPassword['currentPassword'] ? 'text' : 'password'" formControlName="currentPassword" class="customInputFields"
                            [ngClass]="{ 'is-invalid': submitted && f['currentPassword'].invalid }">
                      <i class="fa eye-icon position-absolute" [ngClass]="{ 'fa-eye': !showPassword['currentPassword'], 'fa-eye-slash': showPassword['currentPassword'] }"
                        (mousedown)="togglePasswordVisibility('currentPassword', true)" (mouseup)="togglePasswordVisibility('currentPassword', false)" (mouseleave)="togglePasswordVisibility('currentPassword', false)"
                        style="right: 10px; top: 50%; transform: translateY(-50%); cursor: pointer;"></i>
                      <div *ngIf="submitted && f['currentPassword'].errors?.['required']" class="invalid-feedback">
                        Old password is required.
                      </div>
                    </div>
                  </div> -->
            

                  <div class="mb-3">
                    <label for="refNum" class="col-form-label" style="color: #000000;font-family:'maven pro';font-weight:500;">Create new password</label>
                    <div class="position-relative">
                      <input class="customInputFields" [type]="showPassword['newPassword'] ? 'text' : 'password'" formControlName="newPassword" 
                            [ngClass]="{ 'is-invalid': submitted && f['newPassword'].invalid }" style="border: 1px solid #E4E4E4; border-radius: 7px;">
                      <i class="fa eye-icon position-absolute" [ngClass]="{ 'fa-eye-slash': !showPassword['newPassword'], 'fa-eye': showPassword['newPassword'] }"
                            (click)="togglePasswordVisibility('newPassword')" style="right: 10px; top: 50%; transform: translateY(-50%); cursor: pointer;"></i>
                    </div>
                    <div *ngIf="(submitted || f['newPassword'].touched) && f['newPassword'].errors?.['required']" class="invalid-feedback" style="display: block;">
                        New password is required.
                    </div>
                    <div *ngIf="(submitted || f['newPassword'].touched) && f['newPassword'].errors?.['minlength']" class="invalid-feedback" style="display: block;">
                        Password must be at least 6 characters.
                    </div>
                    <div *ngIf="(submitted || f['newPassword'].touched) && f['newPassword'].errors?.['maxlength']" class="invalid-feedback" style="display: block;">
                        Password must not exceed 40 characters.
                    </div>
                  </div>


                  <!-- <div class="form-group py-2">
                    <label>Create new password</label>
                    <div class="position-relative">
                      <input [type]="showPassword['newPassword'] ? 'text' : 'password'" formControlName="newPassword" class="customInputFields"
                            [ngClass]="{ 'is-invalid': submitted && f['newPassword'].invalid }">
                      <i class="fa eye-icon position-absolute" [ngClass]="{ 'fa-eye': !showPassword['newPassword'], 'fa-eye-slash': showPassword['newPassword'] }"
                        (click)="togglePasswordVisibility('newPassword')" 
                        style="right: 10px; top: 50%; transform: translateY(-50%); cursor: pointer;"></i>
                      <div *ngIf="submitted && f['newPassword'].errors?.['required']" class="invalid-feedback">
                        New password is required.
                      </div>
                      <div *ngIf="submitted && f['newPassword'].errors?.['minlength']" class="invalid-feedback">
                        Password must be at least 6 characters.
                      </div>
                    </div>
                  </div> -->
            

                  <div class="mb-2">
                    <label for="refNum" class="col-form-label" style="color: #000000;font-family:'maven pro';font-weight:500;">Confirm new password</label>
                    <div class="position-relative">
                      <input class="customInputFields" [type]="showPassword['confirmPassword'] ? 'text' : 'password'" formControlName="confirmPassword" 
                            [ngClass]="{ 'is-invalid': submitted && (f['confirmPassword'].invalid || f['confirmPassword'].errors?.['passwordMismatch']) }" 
                            style="border: 1px solid #E4E4E4; border-radius: 7px;">
                      <i class="fa eye-icon position-absolute" [ngClass]="{ 'fa-eye-slash': !showPassword['confirmPassword'], 'fa-eye': showPassword['confirmPassword'] }"
                            (click)="togglePasswordVisibility('confirmPassword')" style="right: 10px; top: 50%; transform: translateY(-50%); cursor: pointer;"></i>
                    </div>
                    <div *ngIf="(submitted || f['confirmPassword'].touched) && f['confirmPassword'].errors?.['required']" class="invalid-feedback" style="display: block;">
                        Confirm password is required.
                    </div>
                    <div *ngIf="(submitted || f['confirmPassword'].touched) && f['confirmPassword'].errors?.['passwordMismatch']" class="invalid-feedback" style="display: block;">
                      Passwords do not match.
                    </div>
                  </div>

          <!-- 
                  <div class="form-group py-2">
                    <label>Confirm new password</label>
                    <div class="position-relative">
                      <input [type]="showPassword['confirmPassword'] ? 'text' : 'password'" formControlName="confirmPassword" class="customInputFields"
                            [ngClass]="{ 'is-invalid': submitted && (f['confirmPassword'].invalid || f['confirmPassword'].errors?.['passwordMismatch']) }">
                      <i class="fa eye-icon position-absolute" [ngClass]="{ 'fa-eye': !showPassword['confirmPassword'], 'fa-eye-slash': showPassword['confirmPassword'] }"
                        (click)="togglePasswordVisibility('confirmPassword')" 
                        style="right: 10px; top: 50%; transform: translateY(-50%); cursor: pointer;"></i>
                      <div *ngIf="submitted && f['confirmPassword'].errors?.['required']" class="invalid-feedback">
                        Confirm password is required.
                      </div>
                      <div *ngIf="submitted && f['confirmPassword'].errors?.['passwordMismatch']" class="invalid-feedback">
                        Passwords do not match.
                      </div>
                    </div>
                  </div> -->

              </div>



              <div>
                <!-- <div *ngIf="errorMessage" style="color: red;">
                  {{ errorMessage }}
                </div> -->

                <!-- <div class="d-flex justify-content-center align-items-center w-100 gap-4 py-3">
                  <button type="button" style="font-size: 1rem;" class="text-nowrap py-1" (click)="cancle()">Cancel</button>
                  <button type="submit" style="font-size: 1rem;" class="text-nowrap py-1">Update password</button>
                </div> -->

                <div class="ms-0 text-end d-flex gap-4 py-3">
                  <button type="button" (click)="cancel()" style="max-width: 100%; background-image: none; color: #000000; border-radius: 6px; height: 50px; border: 1px solid #E4E4E4; background-color: #FFFFFF;" class="customPreCreateTaskButtons">
                    Cancel
                  </button>
                  <button 
                    type="submit" 
                    [ngStyle]="{ 'background-color': changePasswordForm.valid ? '#5ECDA7' : '#E4E4E4' }"
                    style="max-width: 100%; background-image: none; border-radius: 6px; height: 50px; color: #000000;" class="customPreCreateTaskButtons" >
                        Update password
                  </button>
                </div>

              </div>

              


            </div>


          
        </form>
      </div>


    </ng-container>




    <ng-container *ngIf="dialogState === 'reset'">
      
      <!-- Reset Password Form -->
      <div class="d-flex d-flex align-items-center justify-content-center ">

      
        <div class="shadow p-4 pb-2 loginFormMain d-flex flex-column justify-items-stretch justify-content-between" style="width: 500px;">
                <div>
                    <div class="d-flex justify-content-between">
                      <div class="d-flex gap-3 mb-2 align-items-baseline">
                        <svg style="cursor: pointer;" (click)="switchToChange()" width="17" height="16" viewBox="0 0 17 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                          <path d="M4.33474 6.98977L16.5069 6.98977L16.5069 8.98946L4.33545 8.99018L9.69885 14.3536L8.28464 15.7678L0.506469 7.98962L8.28464 0.211449L9.69886 1.62566L4.33474 6.98977Z" fill="black"/>
                        </svg>
                        <h5>Reset Password</h5>
                      </div>
                      
                      <div (click)="cancel()" style="cursor: pointer;">
                        <svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
                          <path d="M17.9427 1.94271L16.0574 0.057373L9.00004 7.11471L1.94271 0.057373L0.057373 1.94271L7.11471 9.00004L0.057373 16.0574L1.94271 17.9427L9.00004 10.8854L16.0574 17.9427L17.9427 16.0574L10.8854 9.00004L17.9427 1.94271Z" fill="black"/>
                        </svg>
                      </div>
                    </div>

                    <hr class="m-0 mb-2" style="background-color: #E4E4E4; border: none; height: 2px;" />

                    <div class="mb-3">
                      <p>We will send an email to the address below with a temporary Security Code to reset your password.</p>
                      <label for="refNum" class="col-form-label" style="color: #000000;font-family:'maven pro';font-weight:500;">E-mail address</label>
                      <input class="customInputFields" type="email" [value]="emailId" style="border: 1px solid #E4E4E4; border-radius: 7px;" disabled>
                    </div>
              
                </div>

                <div>

                  <div class="ms-0 text-end d-flex gap-4 py-3">
                    <button type="button" (click)="cancel()" style="max-width: 100%; background-image: none; color: #000000; border-radius: 6px; height: 50px; border: 1px solid #E4E4E4; background-color: #FFFFFF;" class="customPreCreateTaskButtons">
                      Cancel
                    </button>
                    <button type="button" (click)="sendToken()" 
                      style="max-width: 100%; background-image: none; border-radius: 6px; height: 50px; background-color: #5ECDA7; color: #000000;" class="customPreCreateTaskButtons" >
                          Reset password
                    </button>
                  </div>

                </div>

        </div>







      </div>


    </ng-container>




    <ng-container *ngIf="dialogState === 'new'">
      
      <!-- Reset Password Form -->
      <div class="h-100 d-flex d-flex align-items-center justify-content-center ">

        <form [formGroup]="resetForm" (ngSubmit)="onPasswordReset()" class="h-100 d-flex flex-column justify-content-between">
          <!-- <div class="card text-center" style="width: 300px;" *ngIf="enablePasswordRest"> -->
          <div class=" p-4 pb-2  d-flex flex-column justify-items-stretch " style="width: 500px;">
            
              <!-- <div class="h5 text-center" style="color: #008A70;">Password Reset</div> -->
              <div class="d-flex justify-content-between">
                <div class="d-flex gap-3 mb-2 align-items-baseline">
                  <svg style="cursor: pointer;" (click)="switchToReset()" width="17" height="16" viewBox="0 0 17 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M4.33474 6.98977L16.5069 6.98977L16.5069 8.98946L4.33545 8.99018L9.69885 14.3536L8.28464 15.7678L0.506469 7.98962L8.28464 0.211449L9.69886 1.62566L4.33474 6.98977Z" fill="black"/>
                  </svg>
                  <h5>Set New Password</h5>
                </div>
                
                <div (click)="cancel()" style="cursor: pointer;">
                  <svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M17.9427 1.94271L16.0574 0.057373L9.00004 7.11471L1.94271 0.057373L0.057373 1.94271L7.11471 9.00004L0.057373 16.0574L1.94271 17.9427L9.00004 10.8854L16.0574 17.9427L17.9427 16.0574L10.8854 9.00004L17.9427 1.94271Z" fill="black"/>
                  </svg>
                </div>
              </div>

              <hr class="m-0 mb-2" style="background-color: #E4E4E4; border: none; height: 2px;" />


              <div class="mb-3">
                  <label for="refNum" class="col-form-label" style="color: #000000;font-family:'maven pro';font-weight:500;">Confirm Security Code</label>
                  <div class="position-relative">
                    <input class="customInputFields" type="text" formControlName="generatedToken" 
                          [ngClass]="{ 'is-invalid': submitted && fr['generatedToken'].invalid }" style="border: 1px solid #E4E4E4; border-radius: 7px;">
                  </div>
                  <div *ngIf="(submitted || fr['generatedToken'].touched) && fr['generatedToken'].errors?.['required']" class="invalid-feedback" style="display: block;">
                      Security Code is required
                  </div>
                 
                </div>


               <div class="mb-3">
                  <label for="refNum" class="col-form-label" style="color: #000000;font-family:'maven pro';font-weight:500;">Create new password</label>
                  <div class="position-relative">
                    <input class="customInputFields" [type]="showPassword['pwd'] ? 'text' : 'password'" formControlName="pwd" 
                          [ngClass]="{ 'is-invalid': submitted && fr['pwd'].invalid }" style="border: 1px solid #E4E4E4; border-radius: 7px;">
                    <i class="fa eye-icon position-absolute" [ngClass]="{ 'fa-eye-slash': !showPassword['pwd'], 'fa-eye': showPassword['pwd'] }"
                          (click)="togglePasswordVisibility('pwd')" style="right: 10px; top: 50%; transform: translateY(-50%); cursor: pointer;"></i>
                  </div>
                  <div *ngIf="(submitted || fr['pwd'].touched) && fr['pwd'].errors?.['required']" class="invalid-feedback" style="display: block;">
                      New password is required.
                  </div>
                  <div *ngIf="(submitted || fr['pwd'].touched) && fr['pwd'].errors?.['minlength']" class="invalid-feedback" style="display: block;">
                      Password must be at least 6 characters.
                  </div>
                  <div *ngIf="(submitted || fr['pwd'].touched) && fr['pwd'].errors?.['maxlength']" class="invalid-feedback" style="display: block;">
                      Password must not exceed 40 characters.
                  </div>
                </div> 


                <div class="mb-2">
                    <label for="refNum" class="col-form-label" style="color: #000000;font-family:'maven pro';font-weight:500;">Confirm new password</label>
                    <div class="position-relative">
                      <input class="customInputFields" [type]="showPassword['confirmPassword'] ? 'text' : 'password'" formControlName="confirmPassword" 
                            [ngClass]="{ 'is-invalid': submitted && (fr['confirmPassword'].invalid || fr['confirmPassword'].errors?.['passwordMismatch']) }" 
                            style="border: 1px solid #E4E4E4; border-radius: 7px;">
                      <i class="fa eye-icon position-absolute" [ngClass]="{ 'fa-eye-slash': !showPassword['confirmPassword'], 'fa-eye': showPassword['confirmPassword'] }"
                            (click)="togglePasswordVisibility('confirmPassword')" style="right: 10px; top: 50%; transform: translateY(-50%); cursor: pointer;"></i>
                    </div>
                    <div *ngIf="(submitted || fr['confirmPassword'].touched) && fr['confirmPassword'].errors?.['required']" class="invalid-feedback" style="display: block;">
                        Confirm password is required.
                    </div>
                    <div *ngIf="(submitted || fr['confirmPassword'].touched) && fr['confirmPassword'].errors?.['passwordMismatch']" class="invalid-feedback" style="display: block;">
                      Passwords do not match.
                    </div>
                  </div>



            <!-- <div class="form-group">
              <label class="text-muted py-2" >Confirm Token</label>
              <input type="text" formControlName="generatedToken" class="customInputFields"
                [ngClass]="{ 'is-invalid': submitted && fr['generatedToken'].errors }" />
              <div class="form-group">
                <label class="text-muted py-2" >Password</label>
                <input type="password" formControlName="pwd" class="customInputFields"
                  [ngClass]="{ 'is-invalid': submitted && fr['pwd'].errors }" />
                @if (submitted && fr['pwd'].errors) {
                <div class="invalid-feedback">
                  @if (fr['pwd'].errors['required']) {
                  <div>Password is required</div>
                  } @if (fr['pwd'].errors['minlength']) {
                  <div>Password must be at least 6 characters</div>
                  } @if (fr['pwd'].errors['maxlength']) {
                  <div>Username must not exceed 40 characters</div>
                  }
                </div>
                }
              </div>

              <div class="form-group">
                <label class="text-muted py-2" >Confirm Password</label>
                <input type="password" formControlName="confirmPassword" class="customInputFields"
                  [ngClass]="{ 'is-invalid': submitted && fr['confirmPassword'].errors }" />
                @if (submitted && fr['confirmPassword'].errors) {
                <div class="invalid-feedback">
                  @if (fr['confirmPassword'].errors['required']) {
                  <div>Confirm Password is required</div>
                  } @if (fr['confirmPassword'].errors['matching']) {
                  <div>Confirm Password does not match</div>
                  }
                </div>
                }
              </div>
              <div class="d-flex flex-column justify-content-center align-items-center w-100 gap-3">
                <a (click)="onPasswordReset()" class="customPreActivatedButtons text-nowrap">Submit</a>
              </div>
            </div> -->
          </div>


            <div>

                  <div class="mx-4 text-end d-flex gap-4 py-3">
                    <button type="button" (click)="cancel()" style="max-width: 100%; background-image: none; color: #000000; border-radius: 6px; height: 50px; border: 1px solid #E4E4E4; background-color: #FFFFFF;" class="customPreCreateTaskButtons">
                      Cancel
                    </button>
                    <button type="submit" 
                      style="max-width: 100%; background-image: none; border-radius: 6px; height: 50px; background-color: #5ECDA7; color: #000000;" class="customPreCreateTaskButtons" >
                          Reset password
                    </button>
                  </div>

                </div>



        </form>

      </div>


    </ng-container>



  </div>

    
<!-- </div> -->
